import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from "constants/ThemeConstant";
import { getStoredTheme } from "store/slices/themeConfig";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const AWS_IMAGE_BUCKET_URL = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL;

export const APP_NAME = "iOrel";
export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";
export const REDIRECT_URL_KEY = "redirect";
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/reward/order/list`;

/**
 * Where a signed-in operator lands. The online shop has its own orders screen and no longer has
 * a menu entry for the shared one, so sending its team to the shared path drops them on a page
 * their navigation cannot get back to.
 *
 * Read lazily rather than at module load: the channel is only known once a session exists.
 */
export const authenticatedEntry = () => {
	try {
		// Imported here to keep this config free of a view-layer dependency at module scope.
		const { isOnlineChannel } = require("views/reward-views/sales/orelbuy-orders/utils/onlineDeliveries");
		return isOnlineChannel() ? `${APP_PREFIX_PATH}/reward/orelbuy/order/list` : AUTHENTICATED_ENTRY;
	} catch {
		return AUTHENTICATED_ENTRY;
	}
};
export const UNAUTHENTICATED_ENTRY = "/login";
export const FIRSTTIME_RESET_ENTRY = "/first-reset";
export const IMAGE_UPLOAD_URL = "https://9amzq73qyt.us-east-2.awsapprunner.com/api/v1/iorel/upload/create";

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: "en",
	navType: NAV_TYPE_SIDE,
	mobileNav: false,
	currentTheme: getStoredTheme(),
	direction: DIR_LTR,
	blankLayout: false,
};
